<template>
    <footer
        v-if="!hideRateTableFooter && !hideRateTableFooterAndHeader"
        :class="[
            'site-footer',
            { 'has-legal-text': hasLegalText, 'navigation-hidden': hideNavigation, 'is-rates-table': isRatesTable },
        ]"
    >
        <div :class="[isRatesTable ? 'container-lg' : 'container']" v-if="!hideNavigation">
            <div class="secondary" v-if="!isRatesTable">
                <div class="row">
                    <div class="col d-flex align-items-center justify-content-center justify-content-lg-start">
                        <nav aria-label="Secondary navigation" class="t-small">
                            <slot name="secondary-navigation"></slot>
                        </nav>
                    </div>
                </div>
            </div>

            <div class="rates-table-menu" v-if="isRatesTable">
                <div class="row">
                    <div class="col-6 col-md d-flex align-items-center justify-content-center justify-content-lg-start">
                        <nav aria-label="Secondary navigation" class="t-small">
                            <slot name="rates-table-navigation"></slot>
                        </nav>
                    </div>

                    <div
                        v-if="themeSetting('hide_footer_logo') != 1"
                        :class="[
                            'col-6 d-flex justify-content-center justify-content-lg-end align-items-end mw-100',
                            largeLogoContainer ? 'col-md-4' : 'col-md-2',
                        ]"
                    >
                        <div class="powered-by">
                            <slot name="powered-by"></slot>
                        </div>
                    </div>
                </div>
            </div>

            <div class="primary" v-if="!isRatesTable">
                <div class="footer-copyright-mobile">
                    {{ $t('footer.copyright', { year: new Date().getFullYear() }) }}
                </div>
                <div class="row">
                    <div
                        v-if="themeSetting('hide_footer_logo') != 1"
                        :class="[
                            'col-12 d-flex justify-content-center justify-content-lg-start align-items-center mw-100',
                            largeLogoContainer ? 'col-md-4' : 'col-md-2',
                        ]"
                    >
                        <div class="powered-by">
                            <slot name="powered-by"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <slot name="legal"></slot>
    </footer>
</template>

<script>
import { useStore } from 'vuex'
import get from 'lodash/get'

export default {
    setup() {
        const store = useStore()
        return {
            store,
        }
    },
    props: {
        hasLegalText: Boolean,
        hideNavigation: Boolean,
        largeLogoContainer: Boolean,
        isRatesTable: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        hideRateTableFooter: function () {
            return get(this.store, 'state.global.page.extras.toggle_rate_table_footer', false)
        },
        hideRateTableFooterAndHeader: function () {
            return get(this.store, 'state.global.page.extras.toggle_all_rate_table_filters', false)
        },
    },
}
</script>

<style lang="scss">
@import '~scss/settings/responsive';
@import '~scss/settings/variables';
@import '~scss/mixins/rem';

.site-footer {
    background-color: var(--footer-background-color);
    padding-top: 51px;

    .primary,
    .secondary {
        border-top: 1px solid #e6e8ea;
        padding-bottom: 15px;
        padding-top: 0;
    }

    .primary {
        @media all and (max-width: $bp-large) {
            padding-top: 15px;
        }

        nav {
            a {
                color: var(--footer-primary-link-color);
                font-size: rem(14px);
                font-weight: 700;

                &:hover {
                    filter: brightness(80%);
                }
            }
        }

        .row {
            padding-top: 15px;
            padding-bottom: 15px;
        }
    }

    .secondary,
    .rates-table-menu {
        nav {
            width: 100%;

            ul {
                li {
                    @media all and (min-width: $bp-medium) {
                        &:first-child {
                            margin-left: 0;
                        }
                    }

                    a {
                        color: var(--footer-secondary-link-color);

                        &:hover {
                            filter: brightness(80%);
                        }
                    }
                }
            }
        }
    }

    ul {
        display: flex;
        justify-content: space-between;

        li {
            @media screen and (min-width: $bp-large) {
                padding: 0 0 0 5px;

                &:first-child {
                    padding-left: 0;
                }
            }

            a {
                display: block;
            }
        }
    }

    .rates-table-menu {
        margin: 0 auto;
        max-width: 540px;
        padding: 10px 0px;
        nav {
            ul {
                justify-content: start;

                li {
                    margin-top: 13px;

                    @media screen and (min-width: $bp-medium) {
                        padding: 0 15px;

                        &:first-child {
                            margin-top: 13px;
                            padding-left: 0;
                        }
                    }
                }
            }
        }

        @media screen and (min-width: $bp-medium) {
            max-width: none;
        }

        @media screen and (min-width: $bp-large) {
            max-width: 970px;
        }
    }

    &.has-legal-text {
        padding-bottom: 92px;

        p {
            a {
                color: var(--footer-legal-link-color);

                &:hover {
                    color: var(--footer-legal-link-hover-color);
                }
            }
        }

        div,
        p,
        span {
            color: var(--footer-legal-text-color);
            @media all and (max-width: $bp-large) {
                justify-content: center;
            }
        }
    }

    &.navigation-hidden {
        padding-bottom: 50px;
        padding-top: 50px;
    }

    &.is-rates-table {
        padding: 0;
    }

    .powered-by {
        text-align: center;
    }

    .footer-copyright-mobile {
        display: none;
        font-size: 0.8rem;
        color: var(--footer-secondary-link-color) !important;

        @media all and (max-width: $bp-large) {
            display: block;
            text-align: center;
        }
    }
}
</style>
